// easySetting(설치&연동) 페이지 온보딩 투어
// 핵심 메시지: 사전 설정(리뷰 작성 설정 + 마일리지 설정)을 반드시 먼저 완료한 뒤
// AI 자동 설치 / 상품·리뷰 가져오기를 진행해야 정확하게 동작한다.
import { buildSteps } from '../tourStep';

export function buildEasySettingSteps(ctx, tour) {
  // AI 자동 설치 박스는 모든 단계 완료 시 렌더되지 않음 — 있을 때만 스텝 포함
  const hasAiBox = typeof document !== 'undefined' && !!document.querySelector('#esAiAutoBox');

  return buildSteps([
    {
      id: 'welcome',
      emoji: '🚀',
      title: '설치&연동에 오신 걸 환영해요!',
      text: '이 페이지에서 <b>사전 설정(2가지)</b>과 <b>설치 3단계</b>를 완료하면 온리플 서비스가 시작돼요. 순서가 중요하니 꼭 따라와 주세요 :)',
      attachTo: null,
    },
    {
      id: 'preSetup',
      emoji: '⚠️',
      title: '가장 중요! 사전 설정을 꼭 먼저',
      text: '<b>AI 자동 설치나 상품/리뷰 가져오기를 실행하기 전에</b>, 이 박스의 <b>사전 설정 2가지를 반드시 먼저 완료</b>해 주세요.<br/><br/>' +
        '설정 없이 가져오기를 진행하면 리뷰 노출·마일리지 계산이 기본값으로 처리되어 <b>의도와 다르게 동작</b>할 수 있어요.',
      attachTo: { element: '#esPreSetup', on: 'bottom' },
      beforeShow: '#esPreSetup',
    },
    {
      id: 'preStep1',
      emoji: '📝',
      title: '사전 1 · 리뷰 작성 설정',
      text: '리뷰 작성 양식, 작성 조건, 노출 방식 등 <b>리뷰의 기본 동작</b>을 정의해요. <b>설정하기</b>를 눌러 먼저 완료해 주세요.',
      attachTo: { element: '#esPreStep1', on: 'bottom' },
      beforeShow: '#esPreStep1',
    },
    {
      id: 'preStep2',
      emoji: '🎁',
      title: '사전 2 · 마일리지 설정',
      text: '리뷰 작성 시 지급할 <b>마일리지 규칙</b>을 정해요. 설정하지 않으면 <b>기본값(적립 0원·자동지급 꺼짐)</b>으로 동작하니, 적립금을 운영한다면 꼭 먼저 설정해 주세요.',
      attachTo: { element: '#esPreStep2', on: 'bottom' },
      beforeShow: '#esPreStep2',
    },
    hasAiBox && {
      id: 'aiAuto',
      emoji: '🤖',
      title: 'AI 자동 설치 — 사전 설정 후에!',
      text: '남은 설치 단계(① 상품 → ② 전체 리뷰 → ③ 스킨 활성화)를 <b>클릭 한 번으로 자동 처리</b>해요.<br/><br/>' +
        '<b>단, 반드시 위의 사전 설정 2가지를 완료한 뒤</b> 실행해 주세요. 사전 설정 전에 실행하면 기본값으로 처리됩니다.',
      attachTo: { element: '#esAiAutoBox', on: 'bottom' },
      beforeShow: '#esAiAutoBox',
    },
    {
      id: 'steps',
      emoji: '🧩',
      title: '설치 3단계 (수동 진행)',
      text: '하나씩 직접 진행할 수도 있어요. <b>① 상품 가져오기 → ② 리뷰 가져오기 → ③ 스킨 활성화</b> 순서로 완료하면 설치가 끝나요.',
      attachTo: { element: '#esStep1Card', on: 'top' },
      beforeShow: '#esStep1Card',
    },
    {
      id: 'done',
      emoji: '🎉',
      title: '준비 끝!',
      text: '<b>사전 설정 → AI 자동 설치(또는 3단계 수동 진행)</b> 순서만 기억하세요. 이 가이드는 제목 옆 <b>?</b> 버튼으로 언제든 다시 볼 수 있어요.',
      attachTo: null,
    },
  ], tour);
}

export default buildEasySettingSteps;
